import {
  BookOutlined,
  CaretUpOutlined,
  CheckOutlined,
  ExceptionOutlined,
} from '@ant-design/icons';

import EnforcementStatusEnum from 'redpoints-model-js/enumeration/EnforcementStatusEnum';
import IncidentStatusEnum from 'redpoints-model-js/enumeration/IncidentStatusEnum';

import { translate } from '../../../helpers/languageHelper';
import {
  getDetectionLinkCount,
  getIncidentInfoCounters,
  getIncidentStatusGroups,
} from '../connect';
import {
  generateHomeIcon,
  generateInfoBoxLoader,
  goTo,
  withColumnCopyright,
} from './helpers';

const INCIDENT_LEVEL_GROUP_TO_FILTER = [
  'DETECTION',
  'MATCH',
  'ALERT',
  'INFRINGEMENT',
  'INTERNAL',
];
const ENFORCEMENT_STATUS_TO_FILTER = [
  EnforcementStatusEnum.COMPLAINT_WITHDRAWN,
  EnforcementStatusEnum.ON_ENFORCEMENT,
  EnforcementStatusEnum.OPEN,
  EnforcementStatusEnum.PENDING_ENFORCEMENT,
];

const getCriticalParameters = incidentLevelGroups => ({
  allAssets: true,
  critical: true,
  enforcementStatus: ENFORCEMENT_STATUS_TO_FILTER,
  incidentStatusGroups: incidentLevelGroups.filter(incidentLevelGroup =>
    INCIDENT_LEVEL_GROUP_TO_FILTER.includes(incidentLevelGroup.name)
  ),
});

const getBoxes = context => [
  getDetectionLinkCount(
    context,
    undefined,
    IncidentStatusEnum.PENDING_CONFIRMATION.name
  ),
  getDetectionLinkCount(
    context,
    undefined,
    IncidentStatusEnum.PENDING_REASSESSMENT.name
  ),
  Promise.all([getIncidentStatusGroups(context)])
    .then(
      async ([incidentLevelGroups]) =>
        await getIncidentInfoCounters(
          context,
          getCriticalParameters(incidentLevelGroups)
        )
    )
    .then(response => response.critical),
  getIncidentInfoCounters(context, { watch: true }).then(
    response => response.bookmarked
  ),
];

export default (context, translation, colStyle) => {
  const promiseFns = getBoxes(context);
  return [
    withColumnCopyright(
      generateInfoBoxLoader(
        {
          color: 'blue',
          text: translate('info_box_pending_confirmation'),
          icon: generateHomeIcon(CheckOutlined),
          clickHandler: () => goTo(context, 'pending'),
          className: 'linked',
        },
        () => promiseFns[0],
        translation
      ),
      0,
      null,
      colStyle
    ),
    withColumnCopyright(
      generateInfoBoxLoader(
        {
          color: 'blue',
          text: translate('info_box_pending_reassessment'),
          icon: generateHomeIcon(ExceptionOutlined),
          clickHandler: () => goTo(context, 'pendingReassessment'),
          className: 'linked',
        },
        () => promiseFns[1],
        translation
      ),
      1,
      null,
      colStyle
    ),
    withColumnCopyright(
      generateInfoBoxLoader(
        {
          color: 'red',
          text: translate('info_box_critical'),
          icon: generateHomeIcon(CaretUpOutlined),
          clickHandler: () => goTo(context, 'critical'),
          className: 'linked',
        },
        () => promiseFns[2],
        translation
      ),
      2,
      null,
      colStyle
    ),
    withColumnCopyright(
      generateInfoBoxLoader(
        {
          color: 'green',
          text: translate('info_box_bookmarks'),
          icon: generateHomeIcon(BookOutlined),
          clickHandler: () => goTo(context, 'bookmarks'),
          className: 'linked',
        },
        () => promiseFns[3],
        translation
      ),
      3,
      null,
      colStyle
    ),
  ];
};
